
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh",
  "ja"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_ec18eab9",
      load: () => import("#nuxt-i18n/ec18eab9" /* webpackChunkName: "locale_en_46ts_ec18eab9" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_45CN_46ts_9aa03353",
      load: () => import("#nuxt-i18n/9aa03353" /* webpackChunkName: "locale_zh_45CN_46ts_9aa03353" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_ja_46ts_2cd3cc46",
      load: () => import("#nuxt-i18n/2cd3cc46" /* webpackChunkName: "locale_ja_46ts_2cd3cc46" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/en.ts"
      ]
    },
    {
      code: "zh",
      iso: "zh-CN",
      name: "简体中文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/zh-CN.ts"
      ]
    },
    {
      code: "ja",
      iso: "ja-JP",
      name: "日文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/ja.ts"
      ]
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    iso: "zh-CN",
    name: "简体中文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/zh-CN.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    iso: "ja-JP",
    name: "日文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_one_web/i18n/locales/ja.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/